// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3":"242e5703","489":"391c719a","583":"242e5703","800":"391c719a"}[chunkId] + ".chunk.css";
};